export default __webpack_public_path__ + "static/media/Delivery.ae10bc51.svg";